import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import TeamCell from "@/components/headToHead/TeamStats/TeamCell";
import { createTableData } from "./utils";
import type {
  GetHeadToHeadTeamStatsTabQuery,
  BasicTeam,
} from "@/graphql/gql/graphql";
import type { CellContext } from "@tanstack/react-table";

type Data = {
  team: Pick<BasicTeam, "abbreviation" | "logoSVG">;
  offense_value: number;
  offense_rank: number;
  passing_value: number;
  passing_rank: number;
  rushing_value: number;
  rushing_rank: number;
  defense_value: number;
  defense_rank: number;
  pass_defense_value: number;
  pass_defense_rank: number;
  rush_defense_value: number;
  rush_defense_rank: number;
};

const renderTeamCell = (row: CellContext<Data, BasicTeam>) => (
  <TeamCell
    abbreviation={row.getValue().abbreviation}
    logoSVG={row.getValue().logoSVG}
  />
);

const createColumns = () => {
  const columnHelper = createColumnHelper<Data>();

  return [
    columnHelper.group({
      id: "team",
      header: "",
      columns: [
        columnHelper.accessor("team", {
          header: "Team",
          cell: renderTeamCell,
        }),
      ],
    }),
    columnHelper.group({
      id: "offense",
      header: "Offense",
      columns: [
        columnHelper.accessor("offense_value", {
          header: "Success",
        }),
        columnHelper.accessor("offense_rank", {
          header: "Rank",
        }),
      ],
    }),
    columnHelper.group({
      id: "passing",
      header: "Passing",
      columns: [
        columnHelper.accessor("passing_value", {
          header: "Success",
        }),
        columnHelper.accessor("passing_rank", {
          header: "Rank",
        }),
      ],
    }),
    columnHelper.group({
      id: "rushing",
      header: "Rushing",
      columns: [
        columnHelper.accessor("rushing_value", {
          header: "Success",
        }),
        columnHelper.accessor("rushing_rank", {
          header: "Rank",
        }),
      ],
    }),
    columnHelper.group({
      id: "defense",
      header: "Defense",
      columns: [
        columnHelper.accessor("defense_value", {
          header: "Success",
        }),
        columnHelper.accessor("defense_rank", {
          header: "Rank",
        }),
      ],
    }),
    columnHelper.group({
      id: "pass_defense",
      header: "Pass Defense",
      columns: [
        columnHelper.accessor("pass_defense_value", {
          header: "Success",
        }),
        columnHelper.accessor("pass_defense_rank", {
          header: "Rank",
        }),
      ],
    }),
    columnHelper.group({
      id: "rush_defense",
      header: "Rush Defense",
      columns: [
        columnHelper.accessor("rush_defense_value", {
          header: "Success",
        }),
        columnHelper.accessor("rush_defense_rank", {
          header: "Rank",
        }),
      ],
    }),
  ];
};

const useTeamSuccessRateTable = (
  data: GetHeadToHeadTeamStatsTabQuery["event"]
) => {
  const tableData = useMemo(() => createTableData(data), [data]);
  const columns = useMemo(createColumns, []);

  return {
    columns,
    tableData,
  };
};

export default useTeamSuccessRateTable;
